// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ClipboardEdit as RawClipboardEdit } from "lucide-react";
export const ClipboardEdit = /* @__PURE__ */ createIcon(RawClipboardEdit, "ClipboardEdit", 2);
